import {
  DoNotDisturb,
  Laundry, RoomService,
  Reservation, TrayCollection, Concierge, HouseKeeping, Pressing, CarValet, RoomSupplies, BreakageReport, LostObjects, General, SwimmingPool, ReviewTracking, Upselling,
  Minibar, Feedback, GiftStore, BeachService
} from './components/Icons';

export const getCDNImage = uri => {
  if (uri && uri.indexOf('http') === 0) {
    return uri;
  }
  return process.env.REACT_APP_CDN_URL + uri;
}

export const statusClass = {
  // 'fixed' : {
  //     // 'label' : 'Corregido',
  //     'bgColor' : '#E1F0FF',
  //     'lbColor' : '#3699FF'   
  // },
  // 'pending' : {
  //     // 'label' : 'Pendiente',
  //     'bgColor' : '#17a2b8',
  //     'lbColor' : '#FFFFFF'    
  // },
  // 'in_progress' : {
  //     // 'label' : 'En Proceso',
  //     'variant' : 'info'
  // },
  // 'assigned' : {
  //     // 'label' : 'Asignado',
  //     'variant' : 'success'
  // },
  // 'accepted' : {
  //     // 'label' : 'Aceptado',
  //     'bgColor' : '#28a745',
  //     'lbColor' : '#FFFFFF'
  // },
  // 'observed' : {
  //     // 'label' : 'Observado',
  //     'bgColor' : '#ffc107',
  //     'lbColor' : '#FFFFFF' 
  // },
  // 'canceled' : {
  //     // 'label' : 'Cancelado',
  //     'bgColor' : '#FF0000',
  //     'lbColor' : '#FFFFFF'
  // },
  // 'done' : {
  //     // 'label' : 'Completo',
  //     'bgColor': '#17a2b8',
  //     'lbColor': '#FFFFFF'
  // }
  "pending": "warning",
  "canceled": "danger",
  "_pending": ["Pendiente", "warning"],
  "_observed": ["Observado", "danger", "Observar"],
  "_assigned": ["Asignado", "info", "Asignar"],
  "_accepted": ["Aceptado", "info", "Aceptar"],
  "_in_progress": ["En Proceso", "info", "Iniciar"],
  "_fixed": ["Corregido", "info", "Corregir"],
  "_done": ["Completo", "success", "Finalizar"],
  "_canceled": ["Cancelado", "dark", "Cancelar"]
}

export const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const serviceTypeIcon = (service_type, size = 50) => {
  console.log(service_type)
  switch (service_type) {
    case 'donotdisturb':
      return <DoNotDisturb width={size} height={size} />
    case 'housekeeping':
      return <HouseKeeping width={size} height={size} />
    case 'laundry':
      return <Laundry width={size} height={size} />
    case 'room_service':
      return <RoomService width={size} height={size} />
    case 'pool_service':
      return <SwimmingPool width={size} height={size} />
    case 'tray_collection':
      return <TrayCollection width={size} height={size} />
    case 'concierge':
      return <Concierge width={size} height={size} />
    case 'pressing':
      return <Pressing width={size} height={size} />
    case 'car_valet':
      return <CarValet width={size} height={size} />
    case 'services_booking':
      return <Reservation width={size} height={size} />
    case 'room_supplies':
      return <RoomSupplies width={size} height={size} />
    case 'breakage_report':
      return <BreakageReport width={size} height={size} />
    case 'lost_objects':
      return <LostObjects width={size} height={size} />
    case 'general':
      return <General width={size} height={size} />
    case "review_tracking":
      return <ReviewTracking width={size} height={size} />
    case ("upselling"):
      return <Upselling width={size} height={size} />
    case ("up_selling"):
      return <Upselling width={size} height={size} />
    case 'minibar':
      return <Minibar width={size} height={size} />
    case 'feedback':
      return <Feedback width={size} height={size} />
    case 'items_sales':
      return <RoomService width={size} height={size} />
    case 'gift_store':
      return <GiftStore width={size} height={size} />
    case 'beach_service':
      return <BeachService width={size} height={size} />
    default:
      return null
  }
}